import { render, staticRenderFns } from "./manage-ehr-patients.vue?vue&type=template&id=85c43396&scoped=true"
import script from "./manage-ehr-patients.vue?vue&type=script&lang=js"
export * from "./manage-ehr-patients.vue?vue&type=script&lang=js"
import style0 from "./manage-ehr-patients.vue?vue&type=style&index=0&id=85c43396&prod&scoped=true&lang=css"
import style1 from "./manage-ehr-patients.vue?vue&type=style&index=1&id=85c43396&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c43396",
  null
  
)

export default component.exports